<script setup>

</script>

<template>
  <div class="info-panel">
    <h2 style="text-align: center">个人信息</h2>
  </div>
</template>

<style scoped lang="less">
.info-panel{
  padding: 24px;
}
</style>